import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { AppBar, Typography, Stack, Box, Avatar, Menu, MenuItem, IconButton, Tooltip } from "@mui/material";
import BarChart from "@mui/icons-material/BarChart";
import haskoningLogoWhite from "../../assets/RGB_HaskoningLogo_White.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const NavigationBar = () => {
    const appName = "Dynamic QR";
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogoutRedirect = () => {
        handleClose();
        instance.logoutRedirect().catch((error) => console.log(error));
    };

    /**
     * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
     * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
     * only render their children if a user is authenticated or unauthenticated, respectively.
     */
    return (
        <AppBar
            position="static"
            sx={{
                height: "80px",
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 24px'
            }}
        >
            <img
                style={{
                    maxHeight: "3rem",
                    verticalAlign: 'middle',
                    cursor: 'pointer'
                }}
                src={haskoningLogoWhite}
                alt="RHDHVLogo"
                onClick={() => navigate('/')}
            />
            <Typography
                variant="h3"
                color="white"
                onClick={() => navigate('/')}
                sx={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    cursor: 'pointer'
                }}
            >
                {appName}
            </Typography>
            <Box>
                <AuthenticatedTemplate>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Tooltip title="Statistics">
                            <IconButton
                                onClick={() => navigate('/stats')}
                                sx={{ color: 'white' }}
                            >
                                <BarChart />
                            </IconButton>
                        </Tooltip>
                        <Avatar
                            onClick={handleClick}
                            sx={{ 
                                cursor: 'pointer',
                                bgcolor: 'secondary.main',
                                width: 40,
                                height: 40
                            }}
                        >
                            {accounts[0]?.name?.charAt(0) || 'U'}
                        </Avatar>
                    </Stack>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleLogoutRedirect}>Sign out</MenuItem>
                    </Menu>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate></UnauthenticatedTemplate>
            </Box>
        </AppBar>
    );
};
